import { Box, Typography } from "@mui/material"
import { PropsRightActivity } from "./types"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { icons } from "../../../../../../../../../../utils/icons"
import { Constants } from "../../../../../../../../../../utils/constants"
import { CustomeIconButton } from "../../../../../../../../../../components/customeIconButton"
import React, { useState } from "react"
import SimpleModal from "../../../../../../../../../../components/modal/simpleModal"
import dayjs from "dayjs"
import { DestinationType } from "../../enums/destinationType"



export const RightActivityForm = React.memo((props: PropsRightActivity) => {

    const { t } = useTranslation()
    const styles = useStyles()

    const [openModal, setOpenModal] = useState<{
        open: boolean;
        title?: string;
        description?: string;
        confirm?: () => void;
    }>({ open: false })

    const handleDelete = (id: string) => {
        setOpenModal((prev) => ({ 
            ...prev, 
            open: true, 
            title: t('loogbook.modal.deleteActivityTitle'),
            description: t('loogbook.modal.deleteActivityDescription'),
            confirm: () => {
                props.deleteActivity(id)
                closeModal()
                props.handleDataActivity();
                props.handleChangeCrud({name:'from',date:dayjs().add(1, 'minute')})
                props.setIdToEdit(0)
                props.setDefaultValues({ from: dayjs().add(1, 'minute'), to:null })
                props.setDestinationFinal(undefined)
              }
        }));  
    }

    const closeModal = () => {
        setOpenModal((prev) => ({ ...prev, open: false })); 
    };

    return (<>
        <Box sx={styles.optionsContainer}>
            <Typography sx={styles.title}>{t('loogbook.titles.activities')}</Typography>
            {!props.activities.length ? (
                <Box sx={styles.noActivities}>
                    {icons('calendar')}
                    <Typography sx={styles.text}>{t('loogbook.noActivitiesAssigned')}</Typography>
                </Box>
            ) :
                (
                    <Box sx={styles.activityiesContainer}>
                        {props.activities.map((activity, index) => (<>
                            <Box key={activity.id} sx={styles.activityContainer(activity.error)}>
                                <Box sx={styles.index}>
                                    <Typography>{index + 1}</Typography>
                                </Box>
                                <Box sx={styles.information}>
                                    {!!activity.type?.label && <Typography className="fontBold">{activity.type?.label}</Typography>}
                                    {!!activity.name && <Typography>{activity.name}</Typography>}
                                    { activity.startDate && activity.endDate && 
                                        <Typography sx={styles.smallIcon}>{icons('calendar')} {activity.startDate.format(Constants.dayjsFormat)} - {activity.endDate.format(Constants.dayjsFormat)}</Typography>
                                    }
                                    <Typography sx={styles.smallIcon}>{icons('store')} {activity.destination.name}</Typography>
                                </Box>
                                <Box sx={styles.options(activity.error)}>
                                    <CustomeIconButton 
                                        icon={icons('edit')} 
                                        title={t('breadBrumbs.editAcivity')} 
                                        iconButtonProps={{ 
                                            onClick: () => { 
                                                props.handleDataActivity({
                                                    'title':activity.name,
                                                    'typeOfActivity': activity.type?.label ? {label:activity.type.label, value:activity.type.value, openField:activity.type.openField}:undefined,
                                                    'from':activity.startDate, 
                                                    'to': activity.endDate,
                                                    'open': activity.open,
                                                    'free': activity.free
                                                });
                                                props.setDefaultValues({ from: activity.startDate ? activity.startDate : dayjs().add(1, 'minute') , to: activity.endDate ? activity.endDate : null })
                                                props.setIdToEdit(Number(activity.id))
                                                props.setDestinationFinal({
                                                    id:activity.destination.id,
                                                    latitude:activity.destination.latitude,
                                                    longitude:activity.destination.longitude,
                                                    name:activity.destination.name,
                                                    type:activity.destination.type,
                                                    timeZone: activity.destination.timeZone,
                                                    companyName:activity.destination.companyName,
                                                    compnayId:activity.destination.compnayId,
                                                    direction:activity.destination.direction,
                                                    idDestnation:activity.destination.idDestnation,
                                                    toCreate:activity.destination.toCreate,
                                                    toCreateSelected:activity.destination.toCreateSelected
                                                })
                                                if(activity.destination.type==DestinationType.DESTINATION){
                                                    props.setSelectedPoint({lat:activity.destination.latitude, lng:activity.destination.longitude})
                                                }
                                             } 
                                        }} 
                                        />
                                    <CustomeIconButton 
                                        icon={icons('simple-close')} 
                                        title={t('breadBrumbs.deleteActivity')} 
                                        iconButtonProps={{ onClick: () => { handleDelete(activity.id) } }} 
                                    />
                                </Box>
                            </Box>
                            {activity.errorText && activity.error && <Typography sx={styles.textError(activity.error)}>{activity.errorText}</Typography>}
                        </>))}
                    </Box>
                )}
        </Box>

        <SimpleModal
            open={openModal.open}
            close={() => {
                closeModal()
            }}
            title={openModal?.title}
            description={openModal?.description}
            buttonText={t('general.confirm')}
            cancelText={t('general.cancel')}
            back={() => {
                closeModal()
            }}
            next={() => {
                if (openModal?.confirm) {
                    openModal.confirm()
                }
            }}
        />
    </>)
})